import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "./Logo";
import "../styles/components/menu.scss";
import LanguageToggle from "./LanguageToggle";
import { useI18n } from "../i18n/LanguageProvider";

const Navigation = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  return (
    <div className="navbar-wrap">
      <nav className="navbar glass">
        {/* Logo à gauche */}
        <div className="brand">
          <Logo className="brand-logo" />
        </div>

        {/* Rail central : 3 “pistes” réglables */}
        <div className={`menu-rail ${open ? "open" : ""}`}>
          <NavLink exact to="/" className="menu-link">{t("nav.home")}</NavLink>
          <NavLink to="/Manifeste" className="menu-link">{t("nav.manifesto")}</NavLink>
          <NavLink to="/Programmation" className="menu-link">{t("nav.program")}</NavLink>
        </div>

        <div className="menu-extra"><LanguageToggle /></div>

        {/* Burger (mobile) */}
        <button className="burger" type="button" onClick={() => setOpen(!open)} aria-label="Menu">
          <span/><span/><span/>
        </button>
      </nav>
    </div>
  );
};

export default Navigation;
